import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Form, FormCheck, Row, Button, Spinner } from "react-bootstrap";
import { useHistory, withRouter } from "react-router-dom";
import { Texterror } from "../../../constants/Texterror";
import { Icon } from "@iconify/react";
import { newfacility } from "../../../constants/Validation";
import { useDispatch, useSelector } from "react-redux";
import {
  citylist,
  refTypesList,
} from "../../../redux/actions/dbactions/refactions";
import { getSession } from "../../../redux/actions/authActions";
import { createFacility } from "../../../redux/actions/dbactions/facilityActions";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Header } from "../../Header";
import FacilitiesIcon from "../../../../assets/FacilitiesIcon";

const NewFacility = () => {
  const history = useHistory();
  const [selectedImage, setSelectedImage] = useState(null);
  const dispatch = useDispatch();
  const { user_profile_id, role_id } = getSession();
  const { refsdata, isLoading } = useSelector((state) => state.refstypes);
  const { citis, isLoading: citiesLoading } = useSelector(
    (state) => state.cities
  );
  const { newUser } = useSelector((state) => state.facilitylist);
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState(null);
  const [imageUp, setImageUp] = useState(null);

  const handleCancel = () => {
    history.goBack();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => {};
    if (file) {
      reader.readAsDataURL(file);
      const formData = new FormData();
      formData.append("files", file);
      setImageUp(formData);
    }
  };

  useEffect(() => {
    dispatch(refTypesList());
  }, []);
  useEffect(() => {
    if (newUser?.usr?.rec) {
      history.goBack();
    }
  }, [newUser]);
  const facilityTypes = refsdata.usr?.service_facility_type || [];
  const countryname = refsdata.usr?.iso_cntry || [];
  const citiesName = citis.usr?.iso_city || [];

  const handleCountryChange = (event, setFieldValue) => {
    const selectedCountryId = event.target.value;
    dispatch(citylist(selectedCountryId));

    if (selectedCountryId) {
      setIsCountrySelected(true);
    } else {
      setIsCountrySelected(false);
    }

    setFieldValue("svcf_iso_cntry_id", selectedCountryId);
  };

  const handleCityChange = (event, setFieldValue) => {
    const selectedCityId = event.target.value;
    setSelectedCityId(selectedCityId);
    setFieldValue("svcf_addr_zipcode", selectedCityId);
    setFieldValue("svcf_iso_city_id", selectedCityId);
  };

  const handleFacilityTypeChange = (event, setFieldValue) => {
    const selectedFacilityType = event.target.value;

    const selectedFacilityTypeObject = facilityTypes.find(
      (item) => item.svcft_typ_desc === selectedFacilityType
    );

    const svcft_typ_id = selectedFacilityTypeObject
      ? selectedFacilityTypeObject.svcft_typ_id
      : "";

    setFieldValue("svcf_type_id", svcft_typ_id);
    setFieldValue("svcft_typ_id", svcft_typ_id);
  };

  const neWfacility = (values) => {
    dispatch(createFacility(values));
  };

  return (
    <div>
      <Header
        pageTitle="Facilities & Services > Service List"
        icon={<FacilitiesIcon />}
      />
      <div className="card_white_box">
        <h5 className="globale-title">
          <span>Add Facility</span>
        </h5>
        <Formik
          initialValues={{
            svcf_user_profile_id: user_profile_id,
            svcf_name: "",
            svcf_type_id:
              facilityTypes.length > 0 ? facilityTypes[0].svcft_typ_desc : "",
            svcf_contact_email: "",
            svcf_contact_phone_nbr: "",
            svcf_desc: "",
            sys_user_id: user_profile_id,
            svcf_addr_street1: "",
            svcf_addr_street2: "",
            svcf_iso_cntry_id: "",
            svcf_addr_zipcode: "",
            svcf_iso_city_id:
              citiesName.length > 0 ? citiesName[0].iso_city_id : "",
            role_id: role_id,

            sys_fac_active_yn: "Y",

            svcf_allow_sms_yn: "N",
            svcf_allow_wup_sms_yn: "N",
            picture: null,
          }}
          validationSchema={newfacility}
          onSubmit={(values) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
              formData.append(key, values[key]);
            });
            if (selectedImage) {
              formData.append("picture", selectedImage);
            }
            neWfacility(formData);
          }}
        >
          {({ touched, errors, values, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit} className="sm:px-14 mb-7">
              <Row>
                <Col>
                  <label
                    htmlFor="fileInput"
                    className="image_up mb-2 !rounded-md !h-20"
                  >
                    {selectedImage ? (
                      <div className="image-preview !items-center">
                        <img
                          src={URL.createObjectURL(selectedImage)}
                          alt="Preview"
                        />
                      </div>
                    ) : (
                      <>
                        <div className="open_upload">
                          <Icon
                            icon="line-md:upload-loop"
                            className="mx-auto"
                          />
                          <p>Upload Image</p>
                          <input
                            type="file"
                            accept="image/*"
                            id="fileInput"
                            style={{ display: "none" }}
                            onChange={handleImageChange}
                            name="picture"
                          />
                        </div>
                      </>
                    )}
                  </label>
                  <div style={{ textAlign: "center", marginBottom: "20px" }}>
                    <ErrorMessage name="picture" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <label htmlFor="svcf_name">Facility Name</label>
                    <Field
                      className={`form-control ${
                        touched.svcf_name && errors.svcf_name
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_name"
                      placeholder="Facility Name"
                      type="input"
                      value={values.svcf_name}
                    />
                    <ErrorMessage name="svcf_name" component={Texterror} />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <label htmlFor="svcf_type_id">Facility Type</label>
                    <Form.Select
                      className={`form-control ${
                        touched.svcf_type_id && errors.svcf_type_id
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_type_id"
                      aria-label="Default select example"
                      onChange={(e) =>
                        handleFacilityTypeChange(e, setFieldValue)
                      }
                    >
                      <option>Select Facility Type</option>
                      {facilityTypes.map((item, index) => (
                        <option key={index} value={item.svcft_typ_desc}>
                          {item.svcft_typ_desc}
                        </option>
                      ))}
                    </Form.Select>
                    <ErrorMessage name="svcf_type_id" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <label htmlFor="svcf_contact_email">Email</label>
                    <Field
                      className={`form-control ${
                        touched.svcf_contact_email && errors.svcf_contact_email
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_contact_email"
                      type="email"
                      placeholder="Email"
                      value={values.svcf_contact_email}
                    />
                    <ErrorMessage
                      name="svcf_contact_email"
                      component={Texterror}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <label htmlFor="svcf_contact_phone_nbr">
                      Mobile Number
                    </label>
                    <PhoneInput
                      country={"us"}
                      value={values.svcf_contact_phone_nbr}
                      onChange={(phone) =>
                        setFieldValue("svcf_contact_phone_nbr", phone)
                      }
                      inputProps={{
                        name: "svcf_contact_phone_nbr",
                        required: true,
                        className: `form-control ${
                          touched.svcf_contact_phone_nbr &&
                          errors.svcf_contact_phone_nbr
                            ? "is-invalid"
                            : ""
                        }`,
                      }}
                    />
                    <ErrorMessage
                      name="svcf_contact_phone_nbr"
                      component={Texterror}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="mb-3">
                    <label htmlFor="svcf_desc">Facility Description</label>
                    <Field
                      as="textarea"
                      rows={3}
                      className={`form-control ${
                        touched.svcf_desc && errors.svcf_desc
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_desc"
                      placeholder="Facility Description"
                      value={values.svcf_desc}
                    />
                    <ErrorMessage name="svcf_desc" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="mb-3">
                    <label htmlFor="svcf_addr_street1">Address Line 1</label>
                    <Field
                      className={`form-control ${
                        touched.svcf_addr_street1 && errors.svcf_addr_street1
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_addr_street1"
                      placeholder="Address line 1"
                      type="input"
                      value={values.svcf_addr_street1}
                    />
                    <ErrorMessage
                      name="svcf_addr_street1"
                      component={Texterror}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="svcf_addr_street2">Address Line 2</label>
                    <Field
                      className={`form-control ${
                        touched.svcf_addr_street2 && errors.svcf_addr_street2
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_addr_street2"
                      type="input"
                      value={values.svcf_addr_street2}
                      placeholder="Address line 2"
                    />
                    <ErrorMessage
                      name="svcf_addr_street2"
                      component={Texterror}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col lg={4}>
                  <div className="mb-3">
                    <label htmlFor="svcf_iso_cntry_id">Country</label>
                    <Form.Select
                      className={`form-control ${
                        touched.svcf_iso_cntry_id && errors.svcf_iso_cntry_id
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_iso_cntry_id"
                      aria-label="Default select example"
                      onChange={(e) => handleCountryChange(e, setFieldValue)}
                    >
                      <option value="">Select Country</option>
                      {countryname.map((item, index) => (
                        <option key={index} value={item.iso_cntry_id}>
                          {item.iso_cntry_name}
                        </option>
                      ))}
                    </Form.Select>
                    <ErrorMessage
                      name="svcf_iso_cntry_id"
                      component={Texterror}
                    />
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="mb-3">
                    <label htmlFor="svcf_addr_zipcode">City</label>
                    <div className="position-relative">
                      <Form.Select
                        className={`form-control ${
                          touched.svcf_addr_zipcode && errors.svcf_addr_zipcode
                            ? "is-invalid"
                            : ""
                        }`}
                        name="svcf_addr_zipcode"
                        aria-label="Default select example"
                        onChange={(e) => handleCityChange(e, setFieldValue)}
                        disabled={!isCountrySelected}
                      >
                        <option>Select City</option>
                        {isCountrySelected &&
                          citiesName.map((city) => (
                            <option
                              key={city.iso_city_id}
                              value={city.iso_city_id}
                            >
                              {city.iso_city_name}
                            </option>
                          ))}
                      </Form.Select>
                      {citiesLoading && (
                        <div className="loader-container">
                          <Spinner
                            animation="border"
                            size="sm"
                            variant="primary"
                          />
                        </div>
                      )}
                    </div>
                    <ErrorMessage
                      name="svcf_addr_zipcode"
                      component={Texterror}
                    />
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="mb-3">
                    <label htmlFor="svcf_iso_city_id">Zip Code</label>
                    <Field
                      className={`form-control ${
                        touched.svcf_iso_city_id && errors.svcf_iso_city_id
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_iso_city_id"
                      placeholder="Zip Code"
                      type="input"
                      value={selectedCityId && values.svcf_iso_city_id}
                      readOnly
                    />
                    <ErrorMessage
                      name="svcf_iso_city_id"
                      component={Texterror}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3 flex flex-col">
                <Col lg={6} md={12}>
                  <div className="flex mb-2 items-center gap-2">
                    <FormCheck
                      name="svcf_allow_sms_yn"
                      type="checkbox"
                      id="svcf_allow_sms_yn"
                      checked={values.svcf_allow_sms_yn === "Y"}
                      onChange={() => {
                        setFieldValue(
                          "svcf_allow_sms_yn",
                          values.svcf_allow_sms_yn === "Y" ? "N" : "Y"
                        );
                      }}
                    />
                    <label
                      htmlFor="svcf_allow_sms_yn"
                      className="cursor-pointer"
                    >
                      Yes, contact me via SMS
                    </label>
                    {touched.svcf_allow_sms_yn && errors.svcf_allow_sms_yn && (
                      <div className="invalid-feedback">
                        {errors.svcf_allow_sms_yn}
                      </div>
                    )}
                  </div>
                </Col>
                <Col lg={6} md={12}>
                  <div className="flex mb-2 items-center gap-2">
                    <FormCheck
                      name="svcf_allow_wup_sms_yn"
                      id="svcf_allow_wup_sms_yn"
                      type="checkbox"
                      checked={values.svcf_allow_wup_sms_yn === "Y"}
                      onChange={() => {
                        setFieldValue(
                          "svcf_allow_wup_sms_yn",
                          values.svcf_allow_wup_sms_yn === "Y" ? "N" : "Y"
                        );
                      }}
                    />
                    <label
                      htmlFor="svcf_allow_wup_sms_yn"
                      className="cursor-pointer"
                    >
                      Yes, contact me via Whatsapp
                    </label>
                    {touched.svcf_allow_wup_sms_yn &&
                      errors.svcf_allow_wup_sms_yn && (
                        <div className="invalid-feedback">
                          {errors.svcf_allow_wup_sms_yn}
                        </div>
                      )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="mini_edit flex justify-end gap-1">
                    <button
                      onClick={handleCancel}
                      className="py-2 px-[14px] text-[13px] font-semibold  text-[#26262A] border border-[#E9E9E9] !rounded-md w-32 hover:opacity-80"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className=" py-2 px-[14px] text-[13px] font-semibold bg-[#1340CD] text-white !rounded-md w-32  hover:opacity-80"
                    >
                      Submit
                    </button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default withRouter(NewFacility);
